import axios from "axios";

export const getRecomendacao = axios.create({
  baseURL: "https://api.zoombox.com.br/recomendacao",
  method: "GET",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const getLojas = axios.create({
  baseURL: "https://apiapp.zoombox.com.br/v13/loja",
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
  },
});

export const postAtivaDesconto = axios.create({
  baseURL: "https://api.zoombox.com.br/recomendacao",
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const shareImage = axios.create({
  baseURL: "https://n0435l0psj.execute-api.us-east-1.amazonaws.com/",
  method: "POST"
})
